<div app-kirjanpito-projektien-tyylit [kirjanpidonProjektitObservable]="kirjanpidonProjektitObservable"></div>

<div style="height: 40px; background-color: rgb(62, 203, 244); z-index: 9; position: fixed; left: 0; top: 0; right: 0">
  <!-- Background color -->
</div>

<div class="kirjanpito-container">
  <div class="left-column" [class.kirjaamattomat-auki]="kirjaamattomatAuki">
    <div style="display: flex; position: sticky; top: 0; z-index: 10; height: 40px; background-color: rgb(62, 203, 244); color: white">
      <app-button (click)="clickListaukseen($event)" actionId="Palaa takaisin asiakaslistaukseen" styles="line-height: 40px; color: white; padding: 0 8px 0 16px; min-width: 40px;">
        <i matListItemIcon class="icon ion-ios-heart-empty" style="width: 30px; height: 30px; font-size: 30px"></i>
      </app-button>
      @if (nykyinenAsiakasObservable | async; as asiakas) {
        <app-button (click)="clickKotiin($event)" actionId="Palaa takaisin asiakastietoihin" styles="color: white; padding: 4px 8px 0 8px; min-width: 130px; text-align: left; display: flex; flex-direction: column; justify-content: center;">
          <div style="line-height: 1.2">{{ asiakas.nimi }}</div>
          <div style="font-size: 10px; line-height: 1">{{ asiakas.ytunnus }}</div>
        </app-button>
      }

      @if (showSmallTabsObservable | async) {
        <div class="valilehdet-container">
          <app-button matTooltip="Tositteet" (click)="selectTab('tositteet')" actionId="Kirjanpito: Välilehti: Tositteet" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tositteet' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-picture-o"></span>
          </app-button>
          <app-button matTooltip="Raportit" (click)="selectTab('raportit-uusi')" actionId="Kirjanpito: Välilehti: Raportit" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'raportit-uusi' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-bar-chart"></span>
            <span style="position: absolute; top: -8px; left: 30px" mat-icon-button (click)="avaaUudetRaportitUudessaIkkunassa($event)">
              <span style="font-size: 11px" class="top-icon fa fa-external-link"></span>
            </span>
          </app-button>
          @if (showReskontraObservable | async) {
            <app-button matTooltip="Reskontra" (click)="selectTab('reskontra')" actionId="Kirjanpito: Välilehti: Reskontra" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'reskontra' }" additionalClass="valilehtibutton">
              <span class="top-icon fa fa-link"></span>
            </app-button>
          }
          <app-button (click)="selectTab('tilikartta')" matTooltip="Tilikartta" actionId="Kirjanpito: Välilehti: Tilikartta" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tilikartta' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-bars"></span>
          </app-button>
          <app-button (click)="selectTab('projektit')" matTooltip="Projektit" actionId="Kirjanpito: Välilehti: Projektit" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'projektit' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-tasks"></span>
          </app-button>
          <app-button (click)="selectTab('tilinpaatos')" matTooltip="Tilinpäätös" actionId="Kirjanpito: Välilehti: Tilinpäätös" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tilinpaatos' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-book"></span>
          </app-button>
          <app-button (click)="selectTab('hallinto')" matTooltip="Hallinto" actionId="Kirjanpito: Välilehti: Hallinto" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'hallinto' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-folder"></span>
          </app-button>
        </div>
      } @else {
        <app-button (click)="selectTab('tositteet')" actionId="Kirjanpito: Välilehti: Tositteet" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tositteet' }" additionalClass="valilehtibutton">
          <span class="top-icon fa fa-picture-o"></span>
          <span class="top-title">Tositteet</span>
        </app-button>
        <!-- <button mat-button style="width: 150px; padding-right: 0;" (click)="selectTab('raportit')" [class.aktiivinenValilehti]="valittuvalilehti === 'raportit'" class="valilehtibutton">
        <span class="top-icon fa fa-bar-chart"></span>
        <span class="top-title">Raportit</span>
        <button style="margin: 0 5px;" mat-icon-button (click)="avaaRaportitUudessaIkkunassa($event)">
          <span class="top-icon fa fa-external-link"></span>
        </button>
      </button> -->
        <app-button (click)="selectTab('raportit-uusi')" actionId="Kirjanpito: Välilehti: Raportit" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'raportit-uusi' }" additionalClass="valilehtibutton" styles="width: 150px; padding-right: 0;">
          <span class="top-icon fa fa-bar-chart"></span>
          <span class="top-title">Raportit</span>
          <span style="margin: 0 0 0 5px" mat-icon-button (click)="avaaUudetRaportitUudessaIkkunassa($event)">
            <span class="top-icon fa fa-external-link"></span>
          </span>
        </app-button>
        @if (showReskontraObservable | async) {
          <app-button (click)="selectTab('reskontra')" actionId="Kirjanpito: Välilehti: Reskontra" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'reskontra' }" additionalClass="valilehtibutton">
            <span class="top-icon fa fa-link"></span>
            <span class="top-title">Reskontra</span>
          </app-button>
        }
        <app-button (click)="selectTab('tilikartta')" actionId="Kirjanpito: Välilehti: Tilikartta" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tilikartta' }" additionalClass="valilehtibutton">
          <span class="top-icon fa fa-bars"></span>
          <span class="top-title">Tilikartta</span>
        </app-button>
        <app-button (click)="selectTab('projektit')" actionId="Kirjanpito: Välilehti: Projektit" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'projektit' }" additionalClass="valilehtibutton">
          <span class="top-icon fa fa-tasks"></span>
          <span class="top-title">Projektit</span>
        </app-button>
        <app-button (click)="selectTab('tilinpaatos')" actionId="Kirjanpito: Välilehti: Tilinpäätös" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'tilinpaatos' }" additionalClass="valilehtibutton">
          <span class="top-icon fa fa-book"></span>
          <span class="top-title">Tilinpäätös</span>
        </app-button>
        <app-button (click)="selectTab('hallinto')" actionId="Kirjanpito: Välilehti: Hallinto" [dynamicClass]="{ aktiivinenValilehti: valittuvalilehti === 'hallinto' }" additionalClass="valilehtibutton">
          <span class="top-icon fa fa-folder"></span>
          <span class="top-title">Hallinto</span>
        </app-button>
        <!-- <button mat-button (click)="selectTab('tiedot')" [class.aktiivinenValilehti]="valittuvalilehti === 'tiedot'" class="valilehtibutton">
      <span class="top-icon fa fa-info"></span>
      <span class="top-title">Tiedot</span>
    </button> -->
      }
    </div>

    <div style="display: flex; flex-flow: row; position: sticky; position: -webkit-sticky; top: 40px; height: calc(100vh - 40px); overflow: hidden">
      @if (valittuvalilehti !== 'hallinto') {
        <app-icon-button (click)="toggleKirjaamattomat($event)" [title]="kirjaamattomatAuki ? 'Piilota kirjaamattomat' : 'Näytä kirjaamattomat'" actionId="Piilota / Näytä kirjaamattomat" additionalClass="valilehtibutton" styles="width: 20px; height: 20px; line-height: 20px; position: absolute; left: 0; top: 5px; z-index: 2; padding: 0;">
          <span class="fa" [class.fa-plus]="!kirjaamattomatAuki" [class.fa-minus]="kirjaamattomatAuki" style="width: 20px; height: 20px; line-height: 20px; font-size: 12px"></span>
        </app-icon-button>
      }

      @if (kirjaamattomatAuki && valittuvalilehti !== 'hallinto') {
        <div
          app-kirjanpito-tosite-kirjaamattomat
          [naytettavaKirjausObservable]="valittuNaytettavaKirjausObservable"
          [valittuKuukausiObservable]="valittuKuukausiObservable"
          [valittuKirjanpidonMaksutapaObservable]="valittuMaksutapaObservable"
          (maksutavatJoissaOnKirjaamattomiaTositteita)="maksutavatJoissaOnKirjaamattomiaTositteitaMuuttui($event)"
          style="width: 255px; min-width: 255px; max-width: 255px; overflow: auto; overscroll-behavior: contain"
        ></div>
      }
      <div style="position: relative; flex-grow: 1; padding-left: 10px; min-width: 0">
        <div
          app-kirjanpito-tosite-nayta-kirjauksen-tositteet
          [isMainEnhancedOn]="mainImageQualityEnhanceObservable | async"
          [style.display]="valittuvalilehti === 'tositteet' ? 'flex' : 'none'"
          style="width: 100%"
          [naytettavaKirjausObservable]="valittuNaytettavaKirjausObservable"
          [valittuKuukausiObservable]="valittuKuukausiObservable"
          [laskuasetuksetObservable]="laskuasetuksetObservable"
          [naytaPoistetutKirjauksetObservable]="naytaPoistetutKirjauksetObservable"
        ></div>
        <div [style.display]="valittuvalilehti === 'raportit-uusi' ? 'block' : 'none'" app-kirjanpito-raportit (kirjaustaKlikattiin)="raporttikirjaustaKlikatiinUusi($event)" [valittuKuukausiObservable]="valittuKuukausiObservable" style="height: calc(100vh - 40px); width: 100%; overflow-x: auto; overscroll-behavior: contain"></div>
        <div [style.display]="valittuvalilehti === 'reskontra' ? 'block' : 'none'" app-kirjanpito-reskontra (openKirjaus)="onOpenKirjaus($event)" style="height: calc(100vh - 40px); overflow: auto; padding-right: 15px; margin: 10px auto"></div>
        @if (valittuvalilehti === 'tilikartta') {
          <div asiakkaan-tilikartta-edit (tilikarttaaMuokattiin)="paivitaValittavatTilit()" style="height: calc(100vh - 40px); overflow: auto; padding-right: 15px; max-width: 500px; margin: 10px auto"></div>
        }
        @if (valittuvalilehti === 'projektit') {
          <div app-kirjanpito-projektit-listaus style="height: calc(100vh - 60px); overflow: auto"></div>
        }
        @if (esikatseltavatTositteetObservable | async; as tositteet) {
          <div
            app-kirjanpito-tosite-esikatselu
            [isMainEnhancedOn]="mainImageQualityEnhanceObservable | async"
            [naytettavaKirjausObservable]="valittuNaytettavaKirjausObservable"
            [tositteet]="tositteet"
            (liitaTositeValittuunKirjaukseen)="liitaTositeValittuunKirjaukseenHandler($event)"
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0px; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; padding-top: 30px; padding-right: 50px; padding-bottom: 30px; padding-left: 10px; z-index: 2"
          ></div>
        }
        @if (valittuvalilehti === 'tilinpaatos') {
          <div app-kirjanpito-tilinpaatos (kirjaustaKlikattiin)="raporttikirjaustaKlikatiinUusi($event)" style="height: calc(100vh - 40px); overflow: auto; overscroll-behavior: contain"></div>
        }
        @if (valittuvalilehti === 'hallinto') {
          <div app-kirjanpito-hallinto style="height: calc(100vh - 40px); overflow: auto; overscroll-behavior: contain"></div>
        }
      </div>
    </div>
  </div>

  <div class="kirjanpito-column">
    <div style="display: flex; height: 40px; background-color: rgb(62, 203, 244); color: white; position: sticky; top: 0; z-index: 10">
      <div style="margin: 6px 25px 6px 6px; width: 1px; height: 28px; background-color: #f8f8ff"></div>
      <div style="display: flex; justify-content: space-between; align-items: center; flex-grow: 1">
        <div style="display: flex; align-items: center" class="valkoinen">
          <input style="width: 150px; line-height: 22px; font-size: 13px; border-radius: 15px; padding: 0 8px; box-sizing: border-box; height: min-content" [formField]="naytaVainTileihinRajatut" data-lpignore="true" placeholder="Suodata..." />
          <app-icon-button (click)="toggleComment()" actionId="Kirjanpito: Näytä ja muokkaa muistiinpanoja" [title]="'Näytä ja muokkaa muistiinpanoja: ' + ((nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanot || '')" styles="margin-left: 2rem; height: auto;">
            <span class="fa fa-comment asiakkaanKirjanpitoKommentti" [class.kommenttiPaalla]="(nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanoAuki" [class.kiinniJaKommentti]="(nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanot && !(nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanoAuki"></span>
          </app-icon-button>
          <app-icon-button (click)="toggleVainHyvaksymattomat()" actionId="Kirjanpito: Näytä vain hyväksymättömät kirjaukset" [title]="'Näytä vain hyväksymättömät kirjaukset'" styles="margin-left: 1rem;">
            <span class="mansikka-valitsin" [class.kasittelemattaPallura]="naytaVainHyvaksymattomatObservable | async"></span>
          </app-icon-button>
          @if (naytaTestiObservable | async) {
            <app-icon-button (click)="toggleNaytaPoistetut()" actionId="Kirjanpito: Näytä myös poistetut kirjaukset" [title]="'Näytä myös poistetut kirjaukset'" styles="margin-left: .75rem;">
              <span class="fa fa-ban naytaPoistetutKirjaukset" [class.naytaPoistetutKirjauksetPaalla]="naytaPoistetutKirjauksetObservable | async"></span>
            </app-icon-button>
          }
          @if (kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaObservable | async) {
            <app-icon-button (click)="toggleMuokkaaMitaVain()" actionId="Kirjanpito: Muokkaa mitä tahansa kirjausta" [title]="'Muokkaa mitä tahansa kirjausta'" styles="margin-left: .75rem;">
              <span class="fa fa-pencil naytaPoistetutKirjaukset" [class.naytaPoistetutKirjauksetPaalla]="kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaValittunaObservable | async"></span>
            </app-icon-button>
          }
          <app-icon-button (click)="toggleMainEnhance()" actionId="Kirjanpito: Kuvanlaadun parannus">
            <i class="fa fa-magic paaEnhance" [class.paaEnhancePaalla]="mainImageQualityEnhanceObservable | async"></i>
          </app-icon-button>
          @if (naytaAiAsetuksetObservable | async) {
            <app-icon-button (click)="avaaAiAsetukset()" actionId="Kirjanpito: AI-kirjausehdotusten asetukset" [title]="'AI-kirjausehdotusten asetukset'" matIcon="auto_awesome" styles="margin-left: .75rem; color: rgb(61, 158, 196);"></app-icon-button>
          }
        </div>
        <!-- <div style="line-height: 40px; color: white;">Kuvia ladattu {{tiedostojenValimuistinTilaObservable | async}}</div> -->
        <div app-kirjanpito-kello [currentRuutuObservable]="valittuKuukausiruutuObservable" style="margin-right: 8px; background-color: white; border-radius: 25px"></div>
      </div>
    </div>

    <div class="kirjanpito-column-content">
      <div style="margin: 0" class="k-sticky-header">
        @if ((nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanoAuki) {
          <div style="padding-top: 10px; position: relative">
            <textarea
              [disabled]="muistiinpanojaTallennetaanObservable | async"
              #muistiinpanotTextarea
              style="padding: 4px; display: block; font-size: 16px; line-height: 16px; height: 50px; min-width: 700px; max-width: 700px; width: 700px; margin: auto; border: 1px dashed rgb(124, 124, 124); color: rgb(124, 124, 124)"
              [value]="(nykyinenAsiakasObservable | async)?.kirjanpidonMuistiinpanot ?? ''"
              (blur)="tallennaMuistiinpanot(muistiinpanotTextarea.value)"
            ></textarea>
            @if (muistiinpanojaTallennetaanObservable | async) {
              <div style="display: block; min-width: 700px; max-width: 700px; width: 700px; margin: auto">Tallennetaan... <mat-progress-bar style="display: inline-block; width: 465px; margin-left: 5em" mode="indeterminate"></mat-progress-bar></div>
            }
          </div>
        }

        <div app-kirjanpito-kuukausistrip style="margin-bottom: 15px; padding-top: 10px" (ruutuValittiin)="kuukausiruutuValittiin($event)" [valittuKuukausiObservable]="valittuKuukausiObservable"></div>

        <div class="ktabs ktabs-upper" [style.display]="(lataaObservable | async) ? 'none' : 'flex'">
          <app-kirjanpito-maksutavat [rivinKirjauksetMaksutavoittainObservable]="rivinKirjauksetMaksutavottainObservable" [naytaVeroilmoitusValilehtiObservable]="naytaVeroilmoitusValilehtiObservable" (valittuMaksutapa)="vaihdaValittuMaksutapa($event)"> </app-kirjanpito-maksutavat>
          <app-kirjanpito-lahetykset
            [yhdistettyStatusObservable]="yhdistettyStatusObservable"
            [valittuTabObservable]="valittuTabObservable"
            [naytaVeroilmoitusValilehtiObservable]="naytaVeroilmoitusValilehtiObservable"
            [naytaIlmoitusValilehtiObservable]="naytaIlmoitusValilehtiObservable"
            [veroilmoitusLahetettyObservable]="veroilmoitusLahetettyObservable"
            (vaihdaAlvIlmoitukseen)="vaihdaIlmoituksiin()"
            (vaihdaVeroilmoitukseen)="vaihdaVeroilmoitukseen()"
            (vaihdaLahetaNakymaan)="vaihdaLahetaNakymaan()"
            [onkoSpostejaLahetetty]="onkoSpostejaLahetetty"
          ></app-kirjanpito-lahetykset>
        </div>
      </div>

      <div class="ktab-content" [style.display]="(lataaObservable | async) ? 'none' : 'block'">
        @if (!(valitunKuukaudenTilikausiObservable | async)) {
          <div>
            <div style="height: 400px; display: flex; align-items: center">
              <div class="dark-gray-text" style="font-size: 36px; text-align: center; line-height: 44px; margin: 0 2em">Kuukausi ei kuuluu millekkään tilikaudelle.</div>
            </div>
          </div>
        }

        @if (tilinpaatosWarningObservable | async; as tilipaatosWarning) {
          <div class="red-text warning-text">
            {{ tilipaatosWarning }}
          </div>
        }

        @if (valitunKuukaudenTilikausiObservable | async) {
          @if (valittuTabObservable | async; as valittuTab) {
            <div>
              @if (valittuTab === 'maksutapa' && valitunKuukaudenJaMaksutavanKirjauksetObservable | async; as maksutapaJaKirjaukset) {
                <div style="padding-top: 10px">
                  <pre class="saldo-text">{{ previousMonthEndingSaldoObservable | async }}&nbsp;</pre>
                  @for (kirjaus of maksutapaJaKirjaukset.sivutetutKirjaukset; track trackByKirjausAvainAndUpdateTime($index, kirjaus)) {
                    <div class="kl kl-pysty" [attr.data-kirjausavain]="kirjaus.kirjaus.avain" [attr.data-kirjausnumero]="kirjaus.kirjaus.kirjausnumero" [class.poistettu]="kirjaus.kirjaus.poistettu">
                      <app-icon-button actionId="Avaa kirjausmenu" additionalClass="klp" styles="position: absolute;" matIcon="more_horiz" ariaHaspopup="menu"></app-icon-button>
                      <div class="kvers-top">
                        <span class="knv">{{ kirjaus.kirjaus.kanava }}</span>
                      </div>
                      <div class="kl-paasisalto">
                        <div class="kirj-info">
                          <div class="dark-gray-text pkn selectable-text pnc">{{ kirjaus.kirjaus.kirjausnumero }}</div>
                          <div class="dark-gray-text" [class.tpvm]="maksutapaJaKirjaukset.naytaLisaa && (!kirjaus.lukittu || kirjaus.kirjaus.t === 'b')" style="font-size: 90%; display: inline-block">{{ kirjaus.tilitapahtumanPvm }}</div>
                          <div class="selectable-text kirj-sum" [class.red-text]="0 > kirjaus.kirjaus.kirjauksenSumma && kirjaus.kirjaus.maksutavanTunniste !== '9999'" [class.green-text]="kirjaus.kirjaus.kirjauksenSumma > 0 && kirjaus.kirjaus.maksutavanTunniste !== '9999'">{{ kirjaus.tilitapahtumanSumma }}</div>
                          @if (kirjaus.kirjausKonversioTiedot) {
                            <div (click)="avaaKonversioInfoDialog(kirjaus)" style="font-size: 11px; cursor: pointer">
                              {{ kirjaus.kirjausKonversioTiedot }}
                            </div>
                          }
                          @if (kirjaus.kirjaus.kirjauksenSaajaTaiMaksaja) {
                            <div
                              [class.light-blue-text]="kirjaus.kirjaus.tunniste !== 'omaverotasmaytys_oy_erapaiva' && kirjaus.kirjaus.tunniste !== 'omaverotasmaytys_oy_kk' && kirjaus.kirjaus.tunniste !== 'omaverotasmaytys_tmi_yearly'"
                              [class.dark-purple-text]="kirjaus.kirjaus.tunniste === 'omaverotasmaytys_oy_erapaiva' || kirjaus.kirjaus.tunniste === 'omaverotasmaytys_oy_kk' || kirjaus.kirjaus.tunniste === 'omaverotasmaytys_tmi_yearly'"
                              class="tstm selectable-text"
                            >
                              {{ kirjaus.kirjaus.kirjauksenSaajaTaiMaksaja }}
                            </div>
                          }
                          @if (kirjaus.kirjaus.kirjauksenSaajaTaiMaksajaIban) {
                            <div class="selectable-text" style="padding-top: 1px">{{ kirjaus.kirjaus.kirjauksenSaajaTaiMaksajaIban }}</div>
                          }
                          @if (kirjaus.kirjaus.kirjauksenViitenumero) {
                            <div class="selectable-text" style="padding-top: 7px">Viitenumero: {{ kirjaus.kirjaus.kirjauksenViitenumero }}</div>
                          }
                          @if (kirjaus.kirjaus.vat || kirjaus.uusiVat || kirjaus.kirjauksessaYhteisomyyntiVatKentta) {
                            <div (click)="!kirjaus.lukittu ? avaaVatMuutosDialog(kirjaus) : undefined" [style.cursor]="!kirjaus.lukittu ? 'pointer' : 'default'" style="padding-bottom: 8px">
                              <span>VAT-numero: </span>
                              <span>{{ kirjaus.uusiVat || kirjaus.kirjaus.vat || '-' }}</span>
                            </div>
                          }
                          @if (kirjaus.kirjaus.kirjauksenViesti) {
                            <div class="dark-gray-text selectable-text" style="padding-top: 7px">{{ kirjaus.kirjaus.kirjauksenViesti }}</div>
                          }
                          @if (kirjaus.kirjaus.kirjauksenLemonaidViesti || kirjaus.kirjaus.userApiMessage) {
                            <div class="selectable-text" style="padding-top: 7px; font-weight: bold; color: black">
                              {{ (kirjaus.kirjaus.kirjauksenLemonaidViesti ?? '') + (kirjaus.kirjaus.userApiMessage ? ' ' + kirjaus.kirjaus.userApiMessage : '') }}
                            </div>
                          }
                          @for (rivi of kirjaus.naytettavatKirjausrivit; track rivi) {
                            @if (rivi.projektiNimi || rivi.kirjausrivi.sp?.vastaus || rivi.kirjausrivi.sp?.kuittauskirjausAvain || rivi.kirjausrivi.sp?.alkuperainenKirjausAvain) {
                              <div>
                                @if (rivi.projektiNimi) {
                                  <div>
                                    {{ rivi.projektiNimi }}
                                  </div>
                                }
                                @if (rivi.kirjausrivi.sp?.vastaus) {
                                  <div class="selectable-text" style="padding-top: 7px">
                                    {{ rivi.kirjausrivi.sp?.vastaus }}
                                  </div>
                                }
                                @if (rivi.kirjausrivi.sp?.kuittauskirjausAvain; as kuittauskirjausAvain) {
                                  @if (annaSelvityksenLinkitettyKirjaus(kuittauskirjausAvain) | async; as linkitetty) {
                                    <div class="selvityksen-linkki">
                                      Selvityspyyntöön vastattu, ks. kirjaus <a (click)="siirrySelvityksenLinkitettyynKirjaukseen(linkitetty)">{{ linkitetty.kirjausnumero || 'ilman numeroa' }}</a>
                                    </div>
                                  }
                                }
                                @if (rivi.kirjausrivi.sp?.alkuperainenKirjausAvain; as alkuperainenKirjausAvain) {
                                  @if (annaSelvityksenLinkitettyKirjaus(alkuperainenKirjausAvain) | async; as linkitetty) {
                                    <div class="selvityksen-linkki">
                                      Selvityspyyntö lähti kirjaukselta <a (click)="siirrySelvityksenLinkitettyynKirjaukseen(linkitetty)">{{ linkitetty.kirjausnumero || 'ilman numeroa' }}</a>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          }
                        </div>
                        <div>
                          @if (kirjaus.kirjauksenVirhe) {
                            <div class="error-text">
                              {{ kirjaus.kirjauksenVirhe }}
                            </div>
                          }
                          <div class="kra dark-gray-text">
                            <div class="kna">Tili</div>
                            <div class="kda">Debet</div>
                            <div class="kka">Kredit</div>
                            <div class="kaa">Alv</div>
                            <div class="kkoa">Kirjanpitäjän kommentit</div>
                          </div>
                          @for (rivi of kirjaus.naytettavatKirjausrivit; track rivi) {
                            @let onLlmEhdotus = kirjaus.kirjaus.ehdotus?.lahde === 'llm';
                            <div
                              class="kr"
                              [class.ehdotus-vihrea]="onLlmEhdotus && rivi.kirjausrivi.c > 90"
                              [class.ehdotus-keltainen]="onLlmEhdotus && rivi.kirjausrivi.c >= 80 && rivi.kirjausrivi.c <= 90"
                              [class.ehdotus-punainen]="onLlmEhdotus && rivi.kirjausrivi.c < 80 && rivi.kirjausrivi.c >= 0"
                              [class.lukittu]="rivi.lukittu"
                              [class.selvitettava]="rivi.onSelvitettavaRivi && !rivi.tilivirhe"
                              [attr.data-arvoavain]="rivi.tunniste"
                            >
                              @if (!rivi.lukittu && rivi.projektiNayta) {
                                <div [class]="rivi.projektiVariLuokka + ' kr-projekti-dot'" [title]="rivi.projektiNimi" aria-haspopup="menu" aria-expanded="false"></div>
                              }
                              <div class="knc" [attr.tabindex]="rivi.lukittu || rivi.knTabIndexPoistettu ? null : 0">
                                <div [class.v]="rivi.tilivirhe" class="kn">{{ rivi.tilinumero }}</div>
                                <div class="knr">{{ rivi.tilinimi }}</div>
                              </div>
                              <div [class.v]="rivi.debetvirhe" [attr.tabindex]="rivi.lukittu || rivi.debetlukittu ? null : 0" class="kd" [class.lukittu]="rivi.debetlukittu">{{ rivi.debet }}</div>
                              @if (rivi.kirjausrivi.r && rivi.debet) {
                                <div style="position: relative; left: -65px" app-kirjanpito-reskontra-triangle [kirjausAvain]="kirjaus.kirjaus.avain" [pvm]="kirjaus.kirjaus.p" [rivi]="rivi.kirjausrivi" (triangleClicked)="selectTab('reskontra')"></div>
                              }
                              <div [class.v]="rivi.kreditvirhe" [attr.tabindex]="rivi.lukittu || rivi.kreditlukittu ? null : 0" class="kk" [class.lukittu]="rivi.kreditlukittu">{{ rivi.kredit }}</div>
                              @if (rivi.kirjausrivi.r && rivi.kredit) {
                                <div style="position: relative; left: -65px" app-kirjanpito-reskontra-triangle [kirjausAvain]="kirjaus.kirjaus.avain" [pvm]="kirjaus.kirjaus.p" [rivi]="rivi.kirjausrivi" (triangleClicked)="selectTab('reskontra')"></div>
                              }
                              <div [class.v]="rivi.alvvirhe" [attr.tabindex]="rivi.lukittu || rivi.alvlukittu ? null : 0" class="ka" [class.lukittu]="rivi.alvlukittu">{{ rivi.alv }}</div>
                              @let chip = rivi.onSelvitettavaRivi && !rivi.tilivirhe ? annaSelvityspyynnonChip(rivi) : null;
                              <div [attr.tabindex]="rivi.lukittu ? null : 0" class="kko" [class]="chip ? 'selvitysviesti-solu ' + chip.soluLuokka : ''" [class.selvitysviesti-solu-lukittu]="chip && rivi.lukittu">
                                @if (chip) {
                                  <div class="selvitysviesti-kupla" [class.selvitysviesti-kupla-tyhja]="!rivi.kommentti" [title]="rivi.lukittu ? '' : 'Vaihda tai kirjoita oma viesti'">{{ rivi.kommentti || 'Valitse tai kirjoita viesti…' }}</div>
                                } @else {
                                  {{ rivi.kommentti }}
                                }
                              </div>
                              @if (chip) {
                                <div class="selvitys-chip-rivi">
                                  <app-button [additionalClass]="'selvitys-chip selvityspyynto-nappi skip-space-quick-toggle ' + chip.luokka" [disabled]="rivi.lukittu" actionId="Kirjanpito: Muokkaa selvityspyyntöä" [title]="rivi.lukittu ? 'Kirjaus on lukittu' : 'Muokkaa selvityspyyntöä'">
                                    {{ chip.teksti }}
                                    <span class="fa fa-pencil" aria-hidden="true"></span>
                                  </app-button>
                                </div>
                              }
                            </div>
                          }
                          <div class="krj">
                            <div class="kna"></div>
                            <div class="kda">{{ kirjaus.debetyhteensa }}</div>
                            <div class="kka">{{ kirjaus.kredityhteensa }}</div>
                            <div class="kaa"></div>
                            <div class="kkoa"></div>
                          </div>
                          <div class="kvers">
                            @if (onkoKirjauksellaVastattujaSelvityspyyntoja(kirjaus)) {
                              <app-icon-button
                                class="selvityspyyntohistoria-nappi"
                                (click)="avaaSelvityspyyntojenHistoria(kirjaus, $event)"
                                title="Selvityspyyntöjen historia"
                                ariaLabel="Selvityspyyntöjen historia"
                                actionId="Kirjanpito: Avaa selvityspyyntöjen historia"
                                matIcon="chat_bubble_outline"
                                styles="width: 24px; height: 24px; padding: 0; display: flex; align-items: center; justify-content: center;"
                              ></app-icon-button>
                            }
                            @if (kirjaus.edellisiaVersioita) {
                              <span class="aiempi-versio">&lt; Aiempi versio</span>
                            }
                            {{ kirjaus.tallennustiedot }}
                            @if (kirjaus.seuraaviaVersioita) {
                              <span class="uudempi-versio">Uudempi versio &gt;</span>
                            }
                            <span class="avaa-debug" [class.ei-hyvaksytty]="!kirjaus.tallennetaan && !kirjaus.kirjaus.kirjanpitajaHyvaksynyt && !kirjaus.tallentamattomiaMuutoksia" [class.tallennettu]="!kirjaus.tallennetaan && kirjaus.kirjaus.kirjanpitajaHyvaksynyt && !kirjaus.tallentamattomiaMuutoksia" [class.tallennetaan]="kirjaus.tallennetaan"></span>
                            @if (kirjaus.tallentamattomiaMuutoksia) {
                              <span class="avaa-debug" style="font-size: 12px; position: absolute; top: -15px; right: 0px"> Tallentamattomia muutoksia! <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 15px; padding-left: 3px"></i></span>
                            }
                          </div>
                        </div>
                      </div>
                      @if (kirjaus.kirjaus.ehdotus; as ehdotus) {
                        @if (ehdotus.lahde === 'llm') {
                          <div class="ai-ehdotus">
                            <div class="ai-ehdotus-otsikko">
                              <mat-icon class="ai-ehdotus-tahti">auto_awesome</mat-icon>
                              <span class="ai-ehdotus-teksti">AI-kirjausehdotus - varmuustaso {{ ehdotus.confidenceLevel }} %</span>
                              <app-icon-button (click)="toggleAiEhdotus(kirjaus, $event)" [title]="aiEhdotusAuki(kirjaus) ? 'Piilota perustelu' : 'Näytä perustelu'" actionId="Näytä / piilota AI-kirjausehdotuksen perustelu" styles="width: 20px; height: 20px; line-height: 20px; padding: 0;">
                                <span class="fa" [class.fa-chevron-down]="!aiEhdotusAuki(kirjaus)" [class.fa-chevron-up]="aiEhdotusAuki(kirjaus)" style="display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; font-size: 12px"></span>
                              </app-icon-button>
                            </div>
                            @if (aiEhdotusAuki(kirjaus)) {
                              <div class="ai-ehdotus-sisalto">
                                <div class="ai-ehdotus-perustelu">{{ ehdotus.perustelu }}</div>
                                @if (ehdotus.automaattihyvaksynta; as automaattihyvaksynta) {
                                  <div class="ai-ehdotus-automaatti">
                                    <span class="ai-ehdotus-automaatti-otsikko">Voidaan hyväksyä automaattisesti: {{ automaattihyvaksynta.paatos === 'hyvaksy' ? 'KYLLÄ' : 'EI' }}</span>
                                    @if (automaattihyvaksynta.syy) {
                                      <span> — {{ automaattihyvaksynta.syy }}</span>
                                    }
                                  </div>
                                }
                                @if (!kirjaus.kirjaus.kirjanpitajaHyvaksynyt) {
                                  <div class="ai-ehdotus-palaute">
                                    <span class="ai-ehdotus-palaute-teksti">Onko kirjausehdotus väärin? Ilmoita siitä kehitykseen niin voimme parantaa mallia.</span>
                                    <app-secondary-button (click)="ilmoitaAiEhdotuksesta(kirjaus, $event)" actionId="Avaa AI-kirjausehdotuksen ilmoita-dialogi" styles="font-size: 12px; min-width: 0; padding: 2px 10px;">Ilmoita</app-secondary-button>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                    </div>
                    @if (kirjaus.pvmSaldo) {
                      <pre class="saldo-text">{{ kirjaus.pvmSaldo }}</pre>
                    }
                    @if (kirjaus.pvmPanot) {
                      <pre class="saldo-text">{{ kirjaus.pvmPanot }}</pre>
                    }
                    @if (kirjaus.pvmOtot) {
                      <pre class="saldo-text">{{ kirjaus.pvmOtot }}</pre>
                    }
                  }
                  <!-- <div>{{kirjauksiaPerSivuSubject | async | json}}</div>
                <div>{{valittuSivuSubject | async | json}}</div>
                <div>{{_valittuKuukausiSubject | async | json}}</div> -->
                  @if (maksutapaJaKirjaukset.kirjaukset.length > DEFAULT_KIRJ_PER_PAGE) {
                    <mat-paginator #kirjausPaginator [length]="maksutapaJaKirjaukset.kirjaukset.length" [pageSize]="kirjauksiaPerSivuSubject | async" [pageSizeOptions]="[DEFAULT_KIRJ_PER_PAGE, 500, 1000, 2000]" (page)="vaihdaSivu($event)" [pageIndex]="(valittuSivuSubject | async).sivu - 1"> </mat-paginator>
                  }
                  <pre class="saldo-text" style="padding-top: 20px">{{ maksutapaJaKirjaukset.panot }}</pre>
                  <pre class="saldo-text">{{ maksutapaJaKirjaukset.otot }}</pre>
                  @if (maksutapaJaKirjaukset.kirjaukset.length < 1) {
                    <div style="padding: 30px; text-align: center">
                      @if (onkoSuodattimiaKaytossaObservable | async) {
                        <div>
                          Asiakkaalla ei ole valittuna aikana yhtään suodatusvaihtoehdoilla näkyvää kirjausta.
                          <app-primary-button (click)="poistaSuodattimet()" actionId="Poista kaikki suodattimet kirjauksista" styles="margin-top: 1em;"> Poista kaikki suodattimet </app-primary-button>
                        </div>
                      }
                      <ng-template #eiSuodattimiaTemplate> Asiakkaalla ei ole valittuna aikana yhtään kirjausta. </ng-template>
                    </div>
                  }
                  <!-- {{ maksutapaJaKirjaukset.maksutapa | json }} -->
                  @if (onkoDevaajaTaiItTuki | async) {
                    <app-button (click)="avaaTilitapahtumaDialog()" actionId="Lisää tilitapahtuma manuaalisesti" additionalClass="dark-gray-text" styles="padding-left: 10px; margin-top: 15px;"> Lisää tilitapahtuma </app-button>
                  }
                  @if (maksutapaJaKirjaukset.naytaLisaa) {
                    <app-button (click)="lisaaKirjaus(maksutapaJaKirjaukset)" actionId="Lisää uusi kirjaus" additionalClass="lisaa-kirjaus-button dark-gray-text" styles="padding-left: 10px; margin-top: 15px;"> Lisää kirjaus </app-button>
                  }
                  @if (naytaTestiObservable | async) {
                    <app-button (click)="laskeKirjausnumerotUudelleen()" actionId="Laske kirjausnumerot uudelleen" additionalClass="dark-gray-text" styles="padding-left: 10px; margin-top: 15px;"> Laske kirjausnumerot uudelleen </app-button>
                  }
                  @if (displayBankBalanceEditDialogObservable | async) {
                    <app-button (click)="openBankBalanceEditDialog(maksutapaJaKirjaukset.maksutapa)" actionId="Lisää päiväsaldo manuaalisesti" additionalClass="dark-gray-text" styles="padding-left: 10px; margin-top: 15px;"> Lisää päiväsaldo manuaalisesti </app-button>
                  }
                  @if (maksutapaJaKirjaukset.maksutapa.kirjauksienLuontityyppi === kirjauksienLuontityypit.SAHKOINEN_TILIOTE) {
                    <app-button (click)="lataaTiliote(maksutapaJaKirjaukset.maksutapa)" actionId="Lataa tiliote" additionalClass="dark-gray-text" styles="padding-left: 10px; margin-top: 15px;"> Lataa tiliote </app-button>
                  }
                </div>
              }
              <div [style.display]="valittuTab === 'ilmoitukset' ? 'block' : 'none'">
                <ng-container>
                  <mat-tab-group #ilmoitusTabGroup style="margin-top: 10px" class="ilmoitus-tabs" (selectedIndexChange)="ilmoituksetTabVaihtui($event)" [selectedIndex]="ilmoitusTabSelectedIndexObservable | async">
                    <mat-tab [disabled]="(naytaAlvIlmoitusValilehtiObservable | async) !== true">
                      <ng-template mat-tab-label>
                        ALV-ilmoitus
                        @if ((nykyisellaKuukaudellaOnAlvMuutoksiaObservable | async) !== 'no') {
                          <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 16px; padding-left: 6px"></i>
                        }
                      </ng-template>
                    </mat-tab>
                    <mat-tab [disabled]="(naytaYhteisomyyntiIlmoitusValilehtiObservable | async) !== true">
                      <ng-template mat-tab-label>
                        Yhteisömyynti-ilmoitus
                        @if ((nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaObservable | async) !== 'no') {
                          <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 16px; padding-left: 6px"></i>
                        }
                      </ng-template>
                    </mat-tab>
                  </mat-tab-group>
                  <!-- Komponentit renderöidään aina (vaikka piilossa) jotta ne voivat ladata datansa ja emittoida statuksen -->
                  <div [style.display]="(valittuIlmoitusTabObservable | async) === 'alv' ? 'block' : 'none'" app-kirjanpito-alv-ilmoitus [valittuKuukausiObservable]="valittuKuukausiObservable" (nykyisellaKuukaudellaOnMuutoksia)="nykyisellaKuukaudellaOnAlvMuutoksia($event)" (viimeisinAlvIlmoitus)="setLatestAlvIlmoitus($event)"></div>
                  <div [style.display]="(valittuIlmoitusTabObservable | async) === 'yhteisomyynti' ? 'block' : 'none'" app-kirjanpito-yhteisomyynti-ilmoitus [valittuKuukausiObservable]="valittuKuukausiObservable" (nykyisellaKuukaudellaOnMuutoksia)="nykyisellaKuukaudellaOnYhteisomyyntiMuutoksia($event)"></div>
                </ng-container>
              </div>
              <div [style.display]="valittuTab === 'laheta' ? 'block' : 'none'">
                <div app-kirjanpito-lahetys #kirjanpitoLahetysComponent (onkoSpostejaLahetetty)="setSpostiCheck($event)" [naytaAlvIlmoitusValilehtiObservable]="naytaAlvIlmoitusValilehtiObservable" [latestAlvIlmoitusObservable]="latestAlvIlmoitusObservable" [valittuKuukausiObservable]="valittuKuukausiObservable"></div>
              </div>
              @if (valittuTab === 'vero') {
                <div style="padding: 0 20px 10px 10px">
                  <div app-kirjanpito-veroilmoitus [valittuKuukausiObservable]="valittuKuukausiObservable"></div>
                </div>
              }
            </div>
          }
        }
      </div>

      @if (lataaObservable | async) {
        <div style="display: flex; height: 300px; justify-content: center; align-items: center">
          <mat-spinner></mat-spinner>
        </div>
      }

      <div class="hidden-inputs-for-form">
        <form #inputParkki style="visibility: hidden">
          <input #tnroInput type="text" class="kni" style="width: 100%" [name]="namename" data-lpignore="true" [matAutocomplete]="tiliAuto" />
          <input #debetInput type="text" class="kdi" style="width: 80px" [name]="namename" data-lpignore="true" />
          <input #kreditInput type="text" class="kki" style="width: 80px" [name]="namename" data-lpignore="true" />
          <input #alvInput type="text" class="kai" style="width: 60px" [name]="namename" data-lpignore="true" [matAutocomplete]="alvAuto" />
          <textarea #kommenttiInput type="text" class="kkoi" style="width: 160px" [name]="namename" data-lpignore="true" [matAutocomplete]="kommenttiAuto" cdkTextareaAutosize></textarea>
        </form>
        <mat-autocomplete #tiliAuto="matAutocomplete" panelWidth="400px" class="tili-autocomplete" [displayWith]="displayTiliFn" (optionSelected)="tiliValittiin($event)">
          @for (tili of suodatetutKirjanpitotilitObservable | async; track tili) {
            <mat-option [value]="tili">{{ tili?.numero }} {{ tili?.nimi }}</mat-option>
          }
        </mat-autocomplete>
        <mat-autocomplete #alvAuto="matAutocomplete" panelWidth="400px" [displayWith]="displayAlvFn" (optionSelected)="alvValittiin($event)">
          @for (alv of suodatetutAlvtObservable | async; track alv) {
            <mat-option [value]="alv">{{ alv?.lyhenne }} {{ alv?.nimi }}</mat-option>
          }
        </mat-autocomplete>
        <mat-autocomplete #kommenttiAuto="matAutocomplete" panelWidth="300px" (optionSelected)="kommenttiValittiin($event)">
          @for (kommentti of suodatetutKommentitObservable | async; track kommentti) {
            <mat-option [value]="kommentti">{{ kommentti }}</mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="selvitysviestinValinta?.origin"
  [cdkConnectedOverlayOpen]="!!selvitysviestinValinta"
  [cdkConnectedOverlayPositions]="selvitysviestinValinnanSijainnit"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="suljeSelvitysviestinValinta()"
  (detach)="suljeSelvitysviestinValinta()"
>
  @if (selvitysviestinValinta; as valinta) {
    <div [class]="'selvitysviesti-popover ' + valinta.soluLuokka" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown)="hoidaSelvitysviestinValinnanNappain($event)">
      <div class="selvitysviesti-otsikko">Valitse valmis viesti</div>
      <div class="selvitysviesti-lista" role="listbox">
        @for (viesti of valinta.valmiitViestit; track viesti) {
          @let valittu = viesti === valinta.nykyinenViesti;
          <div class="selvitysviesti-vaihtoehto" role="option" tabindex="0" [class.valittu]="valittu" [attr.aria-selected]="valittu" [attr.cdkFocusInitial]="valittu ? '' : null" (click)="valitseValmisSelvitysviesti(viesti)" (keydown.enter)="valitseValmisSelvitysviesti(viesti); $event.preventDefault()" (keydown.space)="valitseValmisSelvitysviesti(viesti); $event.preventDefault()">
            <span class="selvitysviesti-merkki">
              @if (valittu) {
                <i class="fa fa-check" aria-hidden="true"></i>
              }
            </span>
            <span class="selvitysviesti-teksti">{{ viesti }}</span>
          </div>
        }
      </div>
      <div class="selvitysviesti-erotin"></div>
      <div class="selvitysviesti-otsikko">Tai kirjoita oma</div>
      <textarea class="selvitysviesti-oma" [formField]="selvitysviestiLuonnos" rows="2" placeholder="Kirjoita oma viesti…" data-lpignore="true"></textarea>
      <div class="selvitysviesti-napit">
        <app-secondary-button (click)="suljeSelvitysviestinValinta(true)" actionId="Kirjanpito: Peruuta selvitysviestin valinta">Peruuta</app-secondary-button>
        <app-primary-button (click)="kaytaOmaaSelvitysviestia()" [disabled]="!selvitysviestiLuonnos().value()?.trim()" actionId="Kirjanpito: Käytä omaa selvitysviestiä">Käytä viestiä</app-primary-button>
      </div>
    </div>
  }
</ng-template>

<mat-menu #projektiMenu="matMenu">
  <ng-template matMenuContent let-rivi="rivi" let-kirjaus="kirjaus">
    @for (projekti of naytettavatKirjanpidonProjektit | async; track projekti) {
      <app-menu-item-button (click)="asetaProjekti(kirjaus, rivi, projekti.projekti)" actionId="Aseta projekti" [actionContext]="[projekti.projekti.nimi]" [additionalClass]="'a' + projekti.projekti.avain">
        <span [class]="'a' + projekti.projekti.avain + ' kr-projekti-dot-selection'" [class.kr-projekti-dot-empty]="!projekti.valittu || !projekti.projekti.avain"></span>
        {{ projekti.projekti.nimi }}
      </app-menu-item-button>
    }
  </ng-template>
</mat-menu>

<mat-menu #kirjausMenu="matMenu">
  @if (userRolesObservable | async; as roles) {
    <ng-template matMenuContent let-kirjaus="kirjaus" let-maksutapa="maksutapa">
      @if (kirjaus.kirjaus.poistettu && roles.isYberSuper) {
        <app-menu-item-button (click)="peruutaPoistaKirjaus(kirjaus)" actionId="Peruuta kirjauksen poisto">Peruuta poisto</app-menu-item-button>
      }
      @if (!kirjaus.kirjaus.poistettu) {
        <app-menu-item-button (click)="poistaKirjaus(kirjaus)" [disabled]="!roles.isYberSuper && !kirjaus.naytaPoisto && !kirjaus.kirjaus.avain?.includes('_palkat_')" actionId="Avasi dialogin: Poista kirjaus">Poista kirjaus</app-menu-item-button>
      }
      <app-menu-item-button (click)="siirraKirjaus(kirjaus, roles.isYberSuper)" [disabled]="!roles.isYberSuper && !kirjaus.naytaPoisto && kirjaus.kirjaus.t !== 'b'" actionId="Avasi dialogin: Siirrä kirjaus">Siirrä kirjaus</app-menu-item-button>
      <app-menu-item-button (click)="kopioiKirjaus(kirjaus)" [disabled]="!roles.isYberSuper && !kirjaus.naytaPoisto && !kirjaus.kirjaus.avain?.includes('_palkat_')" actionId="Avasi dialogin: Kopioi kirjaus">Kopioi kirjaus</app-menu-item-button>
      <app-menu-item-button (click)="tulostaKirjaus(kirjaus)" [disabled]="kirjaus.tallentamattomiaMuutoksia" actionId="Tulosta kirjaustosite">Tulosta</app-menu-item-button>
      <app-menu-item-button
        (click)="jaksotaKirjaus(kirjaus)"
        [disabled]="kirjaus.tallentamattomiaMuutoksia || !!kirjaus.kirjaus.t || kirjaus.kirjaus.jaksotus || (kirjanpidonPerusteKirjaukselleObservable | async) === 'LASKU' || (valitunKuukaudenTilikausiObservable | async)?.lukittu || kirjaus.kirjaus.tunniste === 'automaattipoisto_kuluva_tilikausi' || kirjaus.kirjaus.tunniste === 'automaattipoisto_vuosipoisto'"
        actionId="Avasi dialogin: Jaksota kirjaus"
        >Jaksota kirjaus (maksuperusteinen)</app-menu-item-button
      >
      <app-menu-item-button (click)="teeVastakirjaus(kirjaus)" [disabled]="!roles.isYberSuper && !kirjaus.naytaPoisto" actionId="Tee vastakirjaus">Tee vastakirjaus</app-menu-item-button>
      @if ((onkoSuoriteTaiLaskuperusteinenObservable | async) && maksutapa.kirjauksienLuontityyppi === 's') {
        <app-menu-item-button (click)="teeSuoriteperusteinen(kirjaus)" [disabled]="kirjaus.tallentamattomiaMuutoksia || kirjaus.kirjaus.muutettuSuoriteperusteiseksi || !!kirjaus.kirjaus.t || kirjaus.kirjaus.tunniste === 'automaattipoisto_kuluva_tilikausi' || kirjaus.kirjaus.tunniste === 'automaattipoisto_vuosipoisto'" actionId="Avasi dialogin: Kirjaa suoriteperusteisesti"
          >Kirjaa suoriteperusteisesti</app-menu-item-button
        >
      }
      @if ((onkoSuoriteTaiLaskuperusteinenObservable | async) && !kirjaus.kirjaus.avain?.includes('_jaksotus_') && kirjaus.kirjaus.tunniste !== 'automaattipoisto_kuluva_tilikausi' && kirjaus.kirjaus.tunniste !== 'automaattipoisto_vuosipoisto') {
        <app-menu-item-button (click)="jaksotaKuluUseallekuukaudelle(kirjaus.kirjaus)" actionId="Avasi dialogin: Jaksota kulu usealle kuukaudelle">Jaksota kulu usealle kuukaudelle</app-menu-item-button>
      }
      @if (roles.isAdmin) {
        <app-menu-item-button (click)="muokkaaViitenumeroa(kirjaus)" actionId="Avasi dialogin: Muokkaa viitenumeroa">Muokkaa viitenumeroa</app-menu-item-button>
      }
      @if (onkoLlmTestausKayttaja | async) {
        <app-menu-item-button (click)="lisaaLlmTestisettiin(kirjaus)" actionId="Lisää LLM-testisettiin">Lisää LLM-testisettiin</app-menu-item-button>
      }
    </ng-template>
  }
</mat-menu>

<!-- Kirjausrivien valikot avataan komponentin klikkikäsittelijässä näillä, jotta riveillä ei ole omia käynnistimiä -->
<span [appJaettuValikko]="kirjausMenu" #kirjausvalikko="appJaettuValikko" hidden></span>
<span [appJaettuValikko]="projektiMenu" #projektivalikko="appJaettuValikko" hidden></span>
